<template>
  <BRow>
    <BCol cols="12">
      <div class="mb-3 p-4 bg-light rounded-custom">
        <BRow>
          <InfoForAudio />
        </BRow>
      </div>
    </BCol>
  </BRow>
</template>

<script>
import InfoForAudio from "./InfoForAudio";
import AudioPlayer from "./AudioPlayer";

export default {
  name: "InfoAudioComponent",
  components: {
    InfoForAudio,
    AudioPlayer
  }
}
</script>
<style scoped>
.rounded-custom {
  border-radius: 2rem;
}
</style>